import { AxiosResponse } from "axios";
import { IReCAPTCHAApi } from "../base";
import { Result } from "../../models/common/resultResponse";
import { api } from "../base/api";

const baseRoute: string = "Recaptcha";

export class ReCAPTCHAApi extends IReCAPTCHAApi {
	validateRecaptcha(token: string): Promise<AxiosResponse<Result<boolean>, any>> {
		return api.get(`${baseRoute}/validaterecaptcha_public`, {
			params: {
				token,
			},
		});
	}
}
